export const LOADING_DATA = 'LOADING_DATA'
export const DATA_LOADED = 'DATA_LOADED'
export const SET_ADMIN = 'SET_ADMIN'
export const TOGGLE_SENSORS = 'TOGGLE_SENSORS'
export const TOGGLE_CREATE_SENSORS = 'TOGGLE_CREATE_SENSORS'
export const NEW_MAP_ALERT_HIDE = 'NEW_MAP_ALERT_HIDE'
export const NEW_MAP_ALERT_SHOW = 'NEW_MAP_ALERT_SHOW'
export const POST_NEW_MAP = "POST_NEW_MAP"
export const SET_IOT_SENSOR_TRUE = "SET_IOT_SENSOR_TRUE"
export const SET_IOT_SENSOR_FALSE = "SET_IOT_SENSOR_FALSE"
export const TOGGLE_CHART = "TOGGLE_CHART"
export const DISABLE_NOTIFICATION = "DISABLE_NOTIFICATION"
export const ADD_SUBSCRIPTION_ID ="ADD_SUBSCRIPTION_ID"
export const CANCEL_SUBSCRIPTION_ID ="CANCEL_SUBSCRIPTION_ID"


export const addSubscription = (subId) => {
    return {
        type: ADD_SUBSCRIPTION_ID,
        subId
    }
}

export const cancelSubscription= () => {

    return {
        type: CANCEL_SUBSCRIPTION_ID,
    }
}

export const disableNotification = () => {
    return {
        type: DISABLE_NOTIFICATION
    }
}
export const toggleChart = () => {
    return {
        type: TOGGLE_CHART
    }
}

export const loadingData = () => {
    return {
        type: LOADING_DATA,
    }
}

export const postNewMap = (mapSocket) => {
    return {
        type: POST_NEW_MAP,
        mapSocket
    }
}

export const dataLoaded = () => {
    return {
        type: DATA_LOADED
    }
}

export const setAdmin = (admin) => {
    return {
        type: SET_ADMIN,
        admin
    }
}

export const toggleSensors = () => {
    return {
        type: TOGGLE_SENSORS
    }
}

export const toggleCreateSensors = () => {
    return {
        type: TOGGLE_CREATE_SENSORS
    }
}

export const displayPopUp = () => {
    return (dispatch) => {
        dispatch(showNewMapAlert())
        setTimeout(() => {
            dispatch(hideNewMapAlert())
        }, 15000)
    }
}
export const showNewMapAlert = () => {
    return {
        type: NEW_MAP_ALERT_SHOW
    }
}

export const hideNewMapAlert = () => {
    return {
        type: NEW_MAP_ALERT_HIDE
    }
}

export const enableIoTTab = () => {
    return {
        type: SET_IOT_SENSOR_TRUE
    }
}
export const disableIoTTab = () => {
    return {
            type: SET_IOT_SENSOR_FALSE
        }
}


// WEBPACK FOOTER //
// ./src/actions/app.js